import type { TaskStatus } from "../../../shared/types";
import { STATUS_LABELS } from "../../../shared/types";

type FilterValue = "all" | TaskStatus;

interface TaskListFiltersProps {
  readonly filter: FilterValue;
  readonly onFilterChange: (value: FilterValue) => void;
  readonly selectedTag: string | null;
  readonly onTagChange: (tag: string | null) => void;
  readonly allTags: string[];
  readonly counts: Record<string, number>;
}

const FILTERS: { value: FilterValue; label: string }[] = [
  { value: "all", label: "Tout" },
  { value: "todo", label: STATUS_LABELS.todo },
  { value: "doing", label: STATUS_LABELS.doing },
  { value: "done", label: STATUS_LABELS.done },
];

export function TaskListFilters({
  filter,
  onFilterChange,
  selectedTag,
  onTagChange,
  allTags,
  counts,
}: TaskListFiltersProps) {
  return (
    <div className="flex flex-col gap-2 py-2">
      {/* Filtres par statut */}
      <div
        className="flex gap-2"
        role="tablist"
        aria-label="Filtrer par statut"
      >
        {FILTERS.map((f) => (
          <button
            key={f.value}
            type="button"
            role="tab"
            aria-selected={filter === f.value}
            onClick={() => onFilterChange(f.value)}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-full transition-colors ${
              filter === f.value
                ? "bg-accent text-white shadow-sm"
                : "bg-surface text-ink-muted hover:text-ink border border-border/60"
            }`}
          >
            {f.label}
            <span className={`text-[9px] px-1 py-0.5 rounded-full ${
              filter === f.value
                ? "bg-white/20"
                : "bg-surface-alt"
            }`}>
              {counts[f.value] ?? 0}
            </span>
          </button>
        ))}
      </div>

      {/* Filtres par tag */}
      {allTags.length > 0 && (
        <div className="flex gap-1.5 flex-wrap items-center">
          <span className="text-[10px] text-ink-faint uppercase tracking-wide mr-1">
            Tags
          </span>
          <button
            type="button"
            onClick={() => onTagChange(null)}
            className={`px-2.5 py-1 text-[11px] rounded-md transition-colors font-medium ${
              selectedTag === null
                ? "bg-accent/10 text-accent"
                : "text-ink-muted hover:text-ink hover:bg-surface-alt/50 border border-border/60"
            }`}
          >
            Tous
          </button>
          {allTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onTagChange(tag)}
              className={`px-2.5 py-1 text-[11px] rounded-md transition-colors font-medium ${
                selectedTag === tag
                  ? "bg-accent/10 text-accent"
                  : "text-ink-muted hover:text-ink hover:bg-surface-alt/50 border border-border/60"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
